import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { connect } from 'react-redux';
import { FieldArray, reduxForm } from 'redux-form';

import Typography from '@material-ui/core/Typography';

import { DEFAULT_LANGUAGE } from 'pages/create-activity/constants';

import {
  ExpansionPanelWrapper,
  FormActionButtons,
} from 'components';

import { deletedMandatoryFees } from 'actions/activityAndAccommodation';

import validate from './validate';

import { useStyles } from './styles';
import MandatoryFeesFields from 'components/fee-category-section/feeCategorySection';

const initialValues = {
  mandatoryFees: []
};

const MandatoryFees = ({ handleSubmit, setSubmitButton, isUpdate, ...otherProps }) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [t] = useTranslation();

  const { languages, selectedLanguage, deletedMandatoryFees, mandatoryFeesForm } = otherProps;

  const getTitle = item => {
    if (selectedLanguage !== DEFAULT_LANGUAGE) {
      if (item[selectedLanguage]) return item[selectedLanguage].title;
      return '';
    }
    return item.title;
  };

  const onAddHandler = (fields, id) => {
    const { languages } = otherProps;
    const languagesLength = languages.length;
    const secondLanguage = languages[languagesLength - 1];

    let data = {
      id: id,
      title: '',
      description: '',
      USD: '0',
      EUR: '0',
      NOK: '0'
    };

    if (languagesLength > 1) {
      data[secondLanguage] = {
        title: '',
        description: ''
      };
    }

    fields.push(data);
  };

  const onDeleteHandler = item => {
    if (item.isCreated) deletedMandatoryFees(item.id);
  };

  const handleSubmitWrapper = props => {
    if (languages.length > 1) {
      const errors = validate(mandatoryFeesForm.values, otherProps);

      if (Object.keys(errors).length) {
        enqueueSnackbar(
          t(
            'Please fill in all the required fields correctly on the current step for all languages'
          ),
          {
            variant: 'warning'
          }
        );
      }
    }
    handleSubmit(props);
  };

  return (
    <div className={classes.wrapper}>
      <Typography variant="h1" className={classes.title}>
        {t('Mandatory-Fee')}
      </Typography>

      <form onSubmit={handleSubmitWrapper}>
        <FieldArray  
          name="mandatoryFees"
          component={ExpansionPanelWrapper}
          isAddDeleteActions={true}
          add={onAddHandler}
          remove={onDeleteHandler}
          getTitle={item => getTitle(item)}
          tabName="Mandatory-Fee"
          tabNameAll="all mandatory fees"
          children={(field, index, meta) => (
            <MandatoryFeesFields
              field={field}
              index={index}
              meta={meta}
              {...otherProps}
            />
          )}
        />
        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
  );
};

const mapStateToProps = state => ({
  mandatoryFeesForm: state.form.mandatoryFeesForm
});

const mapDispatchToProps = dispatch => ({
  deletedMandatoryFees: id => dispatch(deletedMandatoryFees(id))
});

export default reduxForm({
  form: 'mandatoryFeesForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  validate,
  initialValues
})(connect(mapStateToProps, mapDispatchToProps)(MandatoryFees));
